import { useState } from "react";
import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  ComboboxButton,
} from "@headlessui/react";

import proxy from "api/proxy";
import { cn } from "tools/ui";
import { theme } from "theme/theme";
import { useIntl } from "react-intl";
import { ChevronDownIcon, TrashIcon } from "components/Icons";

function Many2oneFilter(props) {
  const { name, model, data, placeholder, onChange, layout, storeId } = props;
  const intl = useIntl();
  const fieldName = "rec_name";
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(
    typeof data === "object" && data?.id ? data : null,
  );

  async function getOptions(q = "") {
    try {
      const field = layout.fields[name];
      let domain = [];

      const filterRecSearch = layout.filtersConfig?.[name];
      if (filterRecSearch) {
        domain = await filterRecSearch(q);
      } else if (field?.recSearch) {
        domain = await field.recSearch(q);
      } else if (q) {
        domain = [["rec_name", "ilike", `%${q}%`]];
      }

      const { data: res } = await proxy.search(
        model,
        domain,
        ["id", fieldName],
        q ? 20 : undefined,
      );
      setOptions(res || []);
    } catch (error) {
      console.error("Error buscando opciones:", error);
      setOptions([]);
    }
  }

  function handleInput(e) {
    const q = e.target.value;
    if (q.length > 2) getOptions(q);
    else if (q.length === 0) setOptions([]);
  }

  function handleChange(value) {
    setSelected(value);
    onChange?.(name, value);
  }

  function handleClearField() {
    setSelected(null);
    setOptions([]);
    onChange?.(name, null);
  }

  return (
    <div className="relative min-w-[180px]">
      <Combobox value={selected} onChange={handleChange}>
        <ComboboxInput
          className={cn(
            "w-full shadow-sm border border-gray-200 rounded-xl py-2 px-3 bg-white outline-none pr-8",
            theme.textColor,
          )}
          placeholder={
            placeholder ? intl.formatMessage({ id: placeholder }) : "Buscar..."
          }
          displayValue={(v) => v?.[fieldName] || ""}
          onChange={handleInput}
        />

        {options.length > 0 && (
          <ComboboxOptions className="text-xs absolute z-50 mt-1 w-full bg-white rounded-md max-h-40 overflow-y-auto shadow-sm border border-gray-200">
            {options.map((option) => (
              <ComboboxOption
                key={option.id}
                value={option}
                className={({ active }) =>
                  cn(
                    "p-2 cursor-pointer truncate ",
                    active ? "bg-blue-100" : "bg-white",
                  )
                }
              >
                {option?.[fieldName] || option.name}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}

        <ComboboxButton
          as="div"
          className="absolute right-2 top-3 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            if (selected) handleClearField();
            else getOptions("");
          }}
        >
          {selected ? (
            <TrashIcon className="fill-current text-rose-400 size-5" />
          ) : (
            <ChevronDownIcon className="fill-current text-gray-500 size-5" />
          )}
        </ComboboxButton>
      </Combobox>
    </div>
  );
}

export default Many2oneFilter;
